var exports = {
  "Ll": "FeedActivityContent.module__tabIcon___UVR2cG",
  "fO": "FeedActivityContent.module__tabBadge___UVR2cG",
  "XG": "FeedActivityContent.module__scroller___UVR2cG",
  "Ge": "FeedActivityContent.module__rows___UVR2cG",
  "td": "FeedActivityContent.module__rowSlot___UVR2cG",
  "nM": "FeedActivityContent.module__row___UVR2cG",
  "A1": "FeedActivityContent.module__typeIcon___UVR2cG",
  "_z": "FeedActivityContent.module__typeLike___UVR2cG",
  "k8": "FeedActivityContent.module__typeComment___UVR2cG",
  "Gu": "FeedActivityContent.module__typeFollow___UVR2cG",
  "rf": "FeedActivityContent.module__body___UVR2cG",
  "Qq": "FeedActivityContent.module__text___UVR2cG",
  "kB": "FeedActivityContent.module__time___UVR2cG",
  "Zm": "FeedActivityContent.module__unreadDot___UVR2cG",
  "h5": "FeedActivityContent.module__status___UVR2cG",
};

module.exports = exports;
